import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

interface IGoogleTagManagerConfig {
  id: string;
}

interface IWindowWithDataLayer extends Window {
  dataLayer: any[];
}

@Injectable({
  providedIn: 'root'
})
export class GoogleTagManagerService {
  public config: IGoogleTagManagerConfig = { id: '' };
  public googleTagManagerId: string = null;
  private _gtmScriptElementId = 'gtm-script';

  constructor(@Inject(DOCUMENT) private _document: Document) {
    const _sessionTagId = sessionStorage.getItem('GTMCode') || '';
    if (_sessionTagId) {
      this.googleTagManagerId = _sessionTagId;
      this.config.id = _sessionTagId;
      this.addGtmToDom();
    }
  }

  pushTag(_item: Record<string, unknown>): void {
    // Data layer must exist before pushing analytics events.
    const _window = window as unknown as IWindowWithDataLayer;
    _window.dataLayer = _window.dataLayer || [];
    _window.dataLayer.push(_item);
    if (this.googleTagManagerId) {
      this.addGtmToDom();
    }
  }

  addGtmToDom(): void {
    // Avoid adding duplicate GTM scripts when this method is called repeatedly.
    if (!this.googleTagManagerId) {
      return;
    }
    const _existingScript = this._document.getElementById(this._gtmScriptElementId);
    if (_existingScript) {
      return;
    }
    const _firstScript = this._document.getElementsByTagName('script')[0];
    const _script = this._document.createElement('script');
    _script.id = this._gtmScriptElementId;
    _script.async = true;
    _script.src = `https://www.googletagmanager.com/gtm.js?id=${this.googleTagManagerId}`;
    _firstScript?.parentNode?.insertBefore(_script, _firstScript);
  }
}
